module.exports = __webpack_public_path__ + "img/integral-item-bg-4.4e558656.png";